<template>
  <footer class="py-5" id="footer-main">
    <b-container>
      <b-row align-v="center" class="justify-content-xl-between">
        <b-col xl="4">
          <div class="copyright text-center text-xl-left text-muted">
            © {{ year }}
            <a href="/" class="font-weight-bold ml-1" target="_blank">
              BoltScale
            </a>
          </div>
        </b-col>
        <b-col xl="8" class="col-xl-6">
          <b-nav
            class="nav-footer justify-content-center justify-content-xl-end"
          >
            <b-nav-item>
              Made with
              <i class="fa fa-heart" aria-hidden="true"></i>
              in San Francisco
            </b-nav-item>
            <b-nav-item href="mailto:hello@boltscale.io">
              hello@boltscale.io
            </b-nav-item>
            <b-nav-item to="/about">
              About Us
            </b-nav-item>
            <b-nav-item to="/privacy">
              Privacy Policy
            </b-nav-item>
            <b-nav-item to="/terms">
              Terms of Service
            </b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "CustomFooter",
  components: {},
  data: () => ({
    year: new Date().getFullYear()
  }),
  methods: {}
};
</script>

<style>
#footer-main {
  background-color: #f6f9fc;
}
</style>
